// extracted by mini-css-extract-plugin
export default {"dividendsTables":"styles_dividendsTables__Ml1NB","dividendsTablesTitles":"styles_dividendsTablesTitles__UR0Ot","dividendsTablesWrap":"styles_dividendsTablesWrap__wy4nZ"};